export default Vue => {
  Vue.component("v-file", () => import("./v-file.vue"));
};
